import { getAnalyticsConsent, trackEvent, trackStoreClick, type StoreName } from "./analytics";
import type { Lang } from "./seo";
import type { Platform } from "./stores";

/** Keep the existing /download query overrides and platform routing unchanged. */
export function downloadTarget(forced: string | null, platform: Platform): StoreName | null {
  if (forced === "play" || forced === "android" || forced === "google") return "google_play";
  if (forced === "ios" || forced === "apple" || forced === "appstore") return "app_store";
  if (platform === "android") return "google_play";
  if (platform === "ios") return "app_store";
  return null;
}

/** Only a hint for instructions, never used to change the store destination. */
export function isSocialInAppBrowser(userAgent: string): boolean {
  return /FBAN|FBAV|FB_IAB|FBIOS|Instagram/i.test(userAgent);
}

type DownloadEvent = "download_page_visit" | "download_manual_click";
export type DownloadEventParams = {
  page_path: string;
  language: Lang;
  platform: Platform;
  destination: StoreName | "none";
  link_type?: "primary" | "fallback";
};

/** Consent-aware, best-effort telemetry; never awaited or allowed to block a link. */
export function trackDownloadEvent(event: DownloadEvent, params: DownloadEventParams): void {
  try {
    if (getAnalyticsConsent() !== "granted") return;
    trackEvent(event, { ...params, transport_type: "beacon" });
    // Preserve the existing store-click reports (and Meta Lead) for genuine clicks.
    if (event === "download_manual_click" && params.destination !== "none") {
      trackStoreClick(params.destination, `download_${params.link_type}`, params.language);
    }
  } catch {
    // Consent/storage/provider failures must not interfere with navigation.
  }
}
